export enum GeoLocationMode {
  On = "On",
  Off = "Off",
  Watching = "Watching",
}
